// Action Types
import { VOIP_CAMPAIGN_FILTERS } from '@/views/PlaybookMapping/constants'

export const SET_ORGANIZATION_VOIP_CAMPAIGNS = 'organizations/setOrganizationVoipCampaigns'
export const SET_CURRENT_FILTER = 'organizations/setCurrentFilter'
export const SET_LOADING = 'organizations/voipCampaigns/setLoading'

// Action Creators
export const setOrganizationVoipCampaigns = (payload) => ({
  type: SET_ORGANIZATION_VOIP_CAMPAIGNS,
  payload,
})

export const setCurrentFilter = (filter) => ({
  type: SET_CURRENT_FILTER,
  payload: filter,
})

export const setLoading = (payload) => ({
  type: SET_LOADING,
  payload,
})

// State
export const initialState = {
  allCampaigns: [],
  mappedCampaigns: [],
  unmappedCampaigns: [],
  currentFilter: VOIP_CAMPAIGN_FILTERS.MAPPED,
  loading: {
    table: false,
    modal: false,
  },
}

// Reducer
export default function organizationVoipCampaignsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          ...action.payload,
        },
      }
    case SET_ORGANIZATION_VOIP_CAMPAIGNS:
      return {
        ...state,
        allCampaigns: action.payload.allCampaigns || [],
        mappedCampaigns: action.payload.mappedCampaigns || [],
        unmappedCampaigns: action.payload.unmappedCampaigns || [],
      }
    case SET_CURRENT_FILTER:
      return {
        ...state,
        currentFilter: action.payload,
      }
    default:
      return state
  }
}
